/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Certificate
 */
export interface Certificate {
    /**
     * 
     * @type {string}
     * @memberof Certificate
     */
    certificate: string;
    /**
     * 
     * @type {string}
     * @memberof Certificate
     */
    key?: string;
    /**
     * 
     * @type {string}
     * @memberof Certificate
     */
    readonly name: string;
    /**
     * 
     * @type {string}
     * @memberof Certificate
     */
    readonly issuer: string;
    /**
     * 
     * @type {string}
     * @memberof Certificate
     */
    readonly domains: string;
    /**
     * 
     * @type {string}
     * @memberof Certificate
     */
    readonly fingerprint: string;
    /**
     * 
     * @type {string}
     * @memberof Certificate
     */
    readonly notValidBefore: string;
    /**
     * 
     * @type {string}
     * @memberof Certificate
     */
    readonly notValidAfter: string;
    /**
     * 
     * @type {string}
     * @memberof Certificate
     */
    readonly expired: string;
    /**
     * 
     * @type {string}
     * @memberof Certificate
     */
    readonly keyMatches: string;
    /**
     * 
     * @type {string}
     * @memberof Certificate
     */
    readonly domainMatches: string;
}

export function CertificateFromJSON(json: any): Certificate {
    return CertificateFromJSONTyped(json, false);
}

export function CertificateFromJSONTyped(json: any, ignoreDiscriminator: boolean): Certificate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'certificate': json['certificate'],
        'key': !exists(json, 'key') ? undefined : json['key'],
        'name': json['name'],
        'issuer': json['issuer'],
        'domains': json['domains'],
        'fingerprint': json['fingerprint'],
        'notValidBefore': json['not_valid_before'],
        'notValidAfter': json['not_valid_after'],
        'expired': json['expired'],
        'keyMatches': json['key_matches'],
        'domainMatches': json['domain_matches'],
    };
}

export function CertificateToJSON(value?: Certificate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'certificate': value.certificate,
        'key': value.key,
    };
}


